import { render, staticRenderFns } from "./speaker-queue-dialog-component.vue?vue&type=template&id=5dceac4c"
import script from "./speaker-queue-dialog-component.ts?vue&type=script&lang=ts&external"
export * from "./speaker-queue-dialog-component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports